import { useHistory } from 'react-router-dom';
import { ROUTE_OFFERS_V2 } from '../../../config/routes';
import OfferItemV2 from '../OfferItemV2';
import SliderV3 from '../../../global/SliderV3';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../global/Button';
import ArrowRightSvg from '../../../global/SvgComponents/ArrowRight_svg';

import './OffersV2Shelf.scss';

const OffersV2Shelf = ({
  offersList,
  isDashBoard,
  style,
  title,
  ctaTrackerProps = {},
  anchor,
}) => {
  const history = useHistory();

  const handleOnClick = () => { history.push(ROUTE_OFFERS_V2); };

  return (
    <div
      id={anchor}
      className="OffersV2Shelf"
      style={{ ...style }}
    >
      <div className="OffersV2Shelf__container">
        <div className="OffersV2Shelf__container-top">
          {title && (
            <h2 className="OffersV2Shelf__container-top-text">{title}</h2>
          )}
          <Button
            size={BUTTON_SIZE.LARGE}
            type={BUTTON_TYPE.LINK_QUINARY}
            onClick={handleOnClick}
            className="OffersV2Shelf__container-top-cta"
            trackerProps={ctaTrackerProps}
          >
            <ArrowRightSvg color="var(--trashie-ui-faded-black-90)" />
          </Button>
        </div>

        <SliderV3
          breakpoints={{
            992: {
              fixedWidth: '100px',
              perPage: 4,
              gap: '1rem',
            },
            768: {
              fixedWidth: '100px',
              perPage: 3,
              gap: '1rem',
            },
          }}
          slides={offersList.map((offerItem) => ({
            key: `offerv2-shelf-${offerItem.merchantId}`,
            slide: (
              <OfferItemV2
                id={`offer-v2-shelf-${offerItem.merchantId}`}
                key={`offer-v2-${offerItem.merchantId}`}
                offerItem={offerItem}
                isDashBoard={isDashBoard}
              />
            ),
          }
          ))}
        />
      </div>
    </div>
  );
};

export default OffersV2Shelf;
